import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, TextField, Typography } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function ProductionStartScreen() {
  const [scanModal, setScanModal] = useState(false);

  return (
    <ScreenFrame
      title="Production start"
      actions={
        <>
          <Button component={Link} to="/prototype/shopfloor" variant="outlined" size="small">Shopfloor</Button>
          <Button variant="contained" size="small" onClick={() => setScanModal(true)}>Simulate scan</Button>
        </>
      }
    >
      <Typography color="text.secondary" paragraph>Scan pallet to link to production order. Simulate scan opens confirmation.</Typography>
      <TextField fullWidth label="Production order" margin="normal" placeholder="Select or enter order" />
      <Button component={Link} to="/prototype/production-orders" variant="outlined" sx={{ mt: 2 }}>Select order</Button>
      <ConfirmDialog open={scanModal} title="Scan result" message="Pallet P001 linked to production order PO-001." onConfirm={() => setScanModal(false)} onCancel={() => setScanModal(false)} confirmLabel="OK" />
    </ScreenFrame>
  );
}
